import { Input, TextInputProps } from 'imaginarity-react-ui';
import * as React from 'react';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';

export interface EditStringProps<T> extends TextInputProps {
    getter: (value: T) => string | undefined;
}

const EditString = <T extends BaseEditItem = BaseEditItem>(props: EditStringProps<T>) => {
    const { getter } = props;
    const { value: val, setValue: setVal } = useGPEState(getter);

    const inputChange = (value?: string) => {
        setVal(value);
    }

    return (
        <div>
            <Input value={val ?? ""} change={inputChange} {...props} />
        </div>
    );
}

export default EditString;
